import DotSVG from 'components/DotSVG';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';
import { mediaBreakpointDown } from 'utils/styledCssHelpers';

export const SContainer = styled(Container)`
  position: relative;
  padding-top: 150px;
  padding-bottom: 150px;
  ${mediaBreakpointDown(
    'md',
    `
    padding-top: 120px;
    padding-bottom: 0;
`,
  )}
`;

export const SDotSVG = styled(DotSVG)`
  width: 60%;
  top: 55px;
  right: 0;
  overflow: hidden;
`;

export const SSection = styled.section`
  position: relative;
  padding-top: 50px;
  padding-bottom: 50px;
  ${mediaBreakpointDown(
    'md',
    `
  padding-top: 30px;
`,
  )}
`;
